<template>
  <div>
    <div class="d-flex justify-end mb-3">
      <b-action-menu
        v-if="['draft', 'registered'].includes(documentSource.status)"
        :actions="
          [...$directory.get('documentAcceptanceTypes')].map(t => {
            return {
              title: t.name,
              icon: t.id === 1 ? 'mdi-information-outline' : 'mdi-pencil-outline',
              action: () => acceptanceCreate(t.id as number),
              iconProps: {
                color: t.id === 1 ? 'info' : 'warning'
              }
            }
          })
        ">
        <template #activator="{ props }">
          <v-btn color="light-blue-darken-4" v-bind="props">
            <v-icon icon="mdi-plus" class="mr-2"></v-icon>
            <span>Додати на ознайомлення</span>
          </v-btn>
        </template>
      </b-action-menu>
    </div>

    <div v-if="acceptanceList.length || acceptanceConfirmationList.length">
      <div v-if="acceptanceConfirmationList.length">
        <div
          class="font-weight-bold text-uppercase text-grey font-size-15 mb-3">
          Ознайомилися
        </div>

        <acceptance-user
          v-for="acceptanceConfirmation in acceptanceConfirmationList"
          :key="acceptanceConfirmation.id"
          :acceptance-type="acceptanceConfirmation.acceptanceType"
          :user="acceptanceConfirmation.user"
          :confirmed-at="acceptanceConfirmation.confirmed_at"
          type="completed"
          class="mb-3">
        </acceptance-user>
      </div>

      <div v-if="acceptanceList.length">
        <div
          class="font-weight-bold text-uppercase text-grey font-size-15 mb-3">
          До ознайомлення
        </div>

        <v-card
          v-if="acceptanceList.filter(a => a.acceptorTypeId === 1).length"
          border
          style="background: #f0f6fb"
          class="mb-3">
          <v-card-text>
            <div class="d-flex ga-3 align-center mb-3">
              <v-btn
                size="small"
                density="comfortable"
                color="light-blue-darken-4"
                icon="mdi-account-outline"></v-btn>

              <div
                class="text-light-blue-darken-4 font-weight-bold font-size-13">
                Окремо додані співробітники
              </div>

              <v-chip
                color="light-blue-darken-4"
                density="compact"
                variant="flat"
                rounded="pill">
                <span class="font-weight-bold">
                  {{
                    acceptanceList.filter(a => a.acceptorTypeId === 1).length
                  }}
                </span>
              </v-chip>
            </div>

            <div class="bg-white">
              <div
                v-for="(acceptance, idx) in acceptanceList.filter(
                  a => a.acceptorTypeId === 1
                )"
                :key="acceptance.id">
                <acceptance-item :acceptance="acceptance"> </acceptance-item>

                <v-divider
                  v-if="
                    acceptanceList.filter(a => a.acceptorTypeId === 1).length -
                      1 >
                    idx
                  "></v-divider>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card
          v-if="acceptanceList.filter(a => a.acceptorTypeId === 2).length"
          border
          style="background: #fafbfc">
          <v-card-text>
            <div class="d-flex ga-3 align-center mb-3">
              <v-btn
                size="small"
                density="comfortable"
                color="grey-darken-2"
                icon="mdi-office-building-outline"></v-btn>

              <div class="text-grey-darken-4 font-weight-bold font-size-13">
                Окремо додані підрозділи
              </div>

              <v-chip
                color="grey-darken-2"
                density="compact"
                variant="flat"
                rounded="pill">
                <span class="font-weight-bold">
                  {{
                    acceptanceList.filter(a => a.acceptorTypeId === 2).length
                  }}
                </span>
              </v-chip>
            </div>

            <div class="bg-white">
              <acceptance-item
                v-for="acceptance in acceptanceList.filter(
                  a => a.acceptorTypeId === 2
                )"
                :key="acceptance.id"
                :acceptance="acceptance"
                class="mb-3">
              </acceptance-item>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <empty-section
      v-else
      title="Ознайомлень ще немає"
      description="Додайте користувачів на ознайомлення, щоб відстежувати їх підтвердження"></empty-section>
  </div>
</template>

<script setup lang="ts">
import EmptySection from '@/components/EmptySection.vue'
import { BActionMenu } from 'best-modules/components'
import { useDocument } from '../../document'
import AcceptanceUser from './AcceptanceUser.vue'
import AcceptanceItem from './AcceptanceItem.vue'
import { fillDirectory } from '@/directory'

defineOptions({
  name: 'Acceptance',
})

fillDirectory('documentAcceptanceTypes')
const {
  documentSource,
  acceptanceList,
  acceptanceConfirmationList,
  acceptanceCreate,
} = useDocument()
</script>
